document.addEventListener("DOMContentLoaded", function () {
  const formContact = document.querySelector("#form-contact");
  const resetFormButton = document.querySelector("#reset-form-button");

  if (formContact) {
    formContact.addEventListener("submit", async function (event) {
      event.preventDefault();

      const emailInput = formContact.querySelector("#contact-email");
      const newsletterCheckbox = formContact.querySelector(
        "input[name='contact[newsletter]']"
      );
      const statusMessage = document.querySelector("#contact-success-message");

      if (newsletterCheckbox.checked) {
        const klaviyoOptions = {
          method: "POST",
          headers: {
            revision: "2024-02-15",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                custom_source: "Formulaire de contact",
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: emailInput.value,
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: "list",
                    id: "Y2vgpn",
                  },
                },
              },
            },
          }),
        };

        try {
          const klaviyoResponse = await fetch(
            "https://a.klaviyo.com/client/subscriptions/?company_id=Uf5JBs",
            klaviyoOptions
          );

          if (klaviyoResponse.ok) {
            console.log("Email ajouté à la newsletter Klaviyo");
          } else {
            const { errors } = await klaviyoResponse.json();
            console.error("Erreur Klaviyo:", errors);
          }
        } catch (error) {
          console.error("Erreur lors de l'envoi à Klaviyo:", error);
        }
      }

      try {
        const formspreeURL = "https://formspree.io/f/xnnqglgd";
        formContact.setAttribute("action", formspreeURL);

        const formData = new FormData(formContact);

        const formspreeResponse = await fetch(formContact.action, {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          body: formData,
        });

        if (formspreeResponse.ok) {
          formContact.style.display = "none";

          if (statusMessage) {
            statusMessage.classList.remove("d-none");
          }

          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });

          formContact.reset();
        } else {
          console.error("Erreur Formspree:", await formspreeResponse.text());
        }
      } catch (error) {
        console.error("Erreur lors de l'envoi à Formspree:", error);
      }
    });
  }

  if (resetFormButton) {
    resetFormButton.addEventListener("click", function () {
      formContact.style.display = "flex";

      const statusMessage = document.querySelector("#contact-success-message");
      if (statusMessage) {
        statusMessage.classList.add("d-none");
      }

      formContact.reset();

      formContact.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  }
});
